const jsBreakpoints = {
    'xs': 0,
    'sm': 576,
    'md': 768,
    'lg': 992,
    'lg-alt': 1200,
    'xl': 1350
}; 

// Include libraries    
// import {slick} from '@/libraries/slick/slick.min.js';
// import {waypoint} from '@/libraries/jquery.waypoints.min.js';

// Include custom classes/javascript
import MobileDetect from '@/components/MobileDetect';
// import ScrollAnimations from '@/components/ScrollAnimations';
import Form from '@/components/Form';
import Nav from '@/components/Nav';
import Events from '@/components/Events';
import LinkList from '@/components/LinkList';
import Faq from '@/components/Faq';
import AnchorScroll from '@/components/AnchorScroll';
import Header from '@/components/Header';
$(function() {
	const mobileDetect = new MobileDetect();
	mobileDetect.init();

	// const scrollAnimations = new ScrollAnimations();
	// scrollAnimations.init();

    const nav = new Nav();
    nav.init();

    const events = new Events();
    events.init();

    const linkList = new LinkList();
    linkList.init();

    const faq = new Faq();
    faq.init();

    const form = new Form();
    form.init();

    const anchorScroll = new AnchorScroll(jsBreakpoints);
    anchorScroll.init();

    const header = new Header();
    header.init();
});

$(window).on('load', function(){
	// Include scripts here if needed after page load
});


// WEBPACK FOOTER //
// ./wp-content/themes/indiana811/source/scripts/main.js